<template>
  <div class="a-divider"></div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
@import 'a-divider.scss';
</style>
